import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7416c23e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "在线留言", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, " 请详细填写以下资料，以便我们安排对应人员尽快为您服务。如有紧急需求请直接拨打销售热线 获取联系方式 ", -1));
import { reactive, ref } from 'vue';
import { ElButton, ElDialog, ElForm, ElFormItem, ElInput, ElMessage, ElRadioGroup, ElRadio, ElCheckboxGroup, ElCheckbox } from 'element-plus';
import API from '@/api/api';
export default /*#__PURE__*/_defineComponent({
  __name: 'chat-us',
  props: ['visible'],
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: $emit
  }) {
    const props = __props;
    const formLabelAlign = reactive({
      company: '',
      business: '',
      name: '',
      phone: '',
      content: '',
      needSupport: []
    });
    const rules = reactive({
      name: [{
        required: true,
        message: '请输入您的姓名'
      }],
      content: [{
        required: true,
        message: '请输入您的诉求'
      }],
      phone: [{
        required: true,
        message: '请输入您的联系方式'
      }],
      company: [{
        required: true,
        message: '请输入您的公司名称'
      }],
      needSupport: [{
        required: true,
        message: '请选择您的需求'
      }],
      business: [{
        required: true,
        message: '请选择所属行业'
      }]
    });
    const formRef = ref();
    const loading = ref(false);
    const submitForm = () => {
      formRef.value.validate(async valid => {
        if (!valid) {
          return;
        }
        loading.value = true;
        const res = await API.sendOnlineMessage(formLabelAlign).finally(() => {
          loading.value = false;
        });
        if ((res === null || res === void 0 ? void 0 : res.code) === 0) {
          cancel();
          setTimeout(() => {
            ElMessage({
              message: (res === null || res === void 0 ? void 0 : res.responseData) || '尊敬的客户您好，您的信息已经提交，稍后我们将联系您',
              type: 'success',
              offset: 100
            });
          }, 800);
        } else {
          ElMessage({
            message: (res === null || res === void 0 ? void 0 : res.message) || '服务异常',
            type: 'error',
            offset: 200
          });
        }
      });
    };
    const cancel = () => {
      $emit('update:visible', false);
      formRef.value.resetFields();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(ElDialog), {
        width: "592",
        "model-value": props.visible,
        "show-close": true,
        "before-close": cancel,
        class: "chat_us_modal"
      }, {
        header: _withCtx(() => [_hoisted_1]),
        default: _withCtx(() => [_createVNode(_unref(ElForm), {
          ref_key: "formRef",
          ref: formRef,
          rules: rules,
          class: "form",
          "label-position": "left",
          "label-width": "80px",
          model: formLabelAlign
        }, {
          default: _withCtx(() => [_hoisted_2, _createVNode(_unref(ElFormItem), {
            label: "姓名",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElInput), {
              modelValue: formLabelAlign.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formLabelAlign.name = $event),
              modelModifiers: {
                trim: true
              },
              placeholder: "请输入您的姓名",
              maxLength: "50"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElFormItem), {
            label: "联系电话",
            prop: "phone"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElInput), {
              modelValue: formLabelAlign.phone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formLabelAlign.phone = $event),
              modelModifiers: {
                trim: true
              },
              placeholder: "请输入您的联系号码",
              maxLength: "50"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElFormItem), {
            label: "公司名称",
            prop: "company"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElInput), {
              modelValue: formLabelAlign.company,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formLabelAlign.company = $event),
              modelModifiers: {
                trim: true
              },
              maxLength: "50",
              placeholder: "请输入您的公司名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElFormItem), {
            label: "所属行业",
            prop: "business"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElRadioGroup), {
              modelValue: formLabelAlign.business,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formLabelAlign.business = $event)
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElRadio), {
                label: "水利"
              }, {
                default: _withCtx(() => [_createTextVNode("水利")]),
                _: 1
              }), _createVNode(_unref(ElRadio), {
                label: "海洋"
              }, {
                default: _withCtx(() => [_createTextVNode("海洋")]),
                _: 1
              }), _createVNode(_unref(ElRadio), {
                label: "畜牧"
              }, {
                default: _withCtx(() => [_createTextVNode("畜牧")]),
                _: 1
              }), _createVNode(_unref(ElRadio), {
                label: "应急安全"
              }, {
                default: _withCtx(() => [_createTextVNode("应急安全")]),
                _: 1
              }), _createVNode(_unref(ElRadio), {
                label: "农业"
              }, {
                default: _withCtx(() => [_createTextVNode("农业")]),
                _: 1
              }), _createVNode(_unref(ElRadio), {
                label: "林业"
              }, {
                default: _withCtx(() => [_createTextVNode("林业")]),
                _: 1
              }), _createVNode(_unref(ElRadio), {
                label: "其他"
              }, {
                default: _withCtx(() => [_createTextVNode("其他")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElFormItem), {
            label: "您的需求",
            prop: "needSupport"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElCheckboxGroup), {
              modelValue: formLabelAlign.needSupport,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formLabelAlign.needSupport = $event)
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElCheckbox), {
                label: "获取方案"
              }, {
                default: _withCtx(() => [_createTextVNode("获取方案")]),
                _: 1
              }), _createVNode(_unref(ElCheckbox), {
                label: "产品试用"
              }, {
                default: _withCtx(() => [_createTextVNode("产品试用")]),
                _: 1
              }), _createVNode(_unref(ElCheckbox), {
                label: "生态合作"
              }, {
                default: _withCtx(() => [_createTextVNode("生态合作")]),
                _: 1
              }), _createVNode(_unref(ElCheckbox), {
                label: "其他需求"
              }, {
                default: _withCtx(() => [_createTextVNode("其他需求")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElFormItem), {
            label: "需求描述",
            prop: "content"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElInput), {
              modelValue: formLabelAlign.content,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formLabelAlign.content = $event),
              type: "textarea",
              rows: 5,
              class: "textarea",
              placeholder: "请输入需求描述",
              maxLength: "100"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["rules", "model"]), _createVNode(_unref(ElButton), {
          loading: loading.value,
          onClick: submitForm,
          class: "submit"
        }, {
          default: _withCtx(() => [_createTextVNode("提交")]),
          _: 1
        }, 8, ["loading"])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
});